import { jsxs, jsx } from "react/jsx-runtime";
function ExitFullScreenIcon() {
  const size = "24";
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      width: size,
      height: size,
      viewBox: `0 0 ${size} ${size}`,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "m 4.6803502,21.299549 3.9602241,-3.960225 2.2347127,2.234712 V 13.124712 H 4.4259622 l 2.234714,2.234712 -3.960224,3.960222 z",
            fill: "white",
            id: "arrow"
          }
        ),
        /* @__PURE__ */ jsx(
          "use",
          {
            x: "0",
            y: "0",
            xlinkHref: "#arrow",
            transform: "rotate(180,12,12)",
            width: "100%",
            height: "100%"
          }
        )
      ]
    }
  );
}
export {
  ExitFullScreenIcon
};
//# sourceMappingURL=index.js.map
